var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3596 17.625C32.3803 9.41828 25.7444 2.74861 17.5377 2.72783C9.331 2.70705 2.66133 9.34302 2.64055 17.5497C2.62195 24.8936 7.97099 31.1496 15.2286 32.2722V21.913H11.4076V17.6675H15.1968V14.3558C15.1968 10.6409 17.3939 8.58177 20.7798 8.58177C21.89 8.59792 22.9972 8.70083 24.0913 8.88957V12.5089H22.2338C21.0748 12.3323 19.9921 13.1286 19.8155 14.2876C19.7879 14.4683 19.7838 14.6517 19.8033 14.8334V17.6143H23.9215L23.2634 21.8598H19.8033V32.219C27.0003 31.09 32.3174 24.9099 32.3596 17.6249",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.a1b1525ef5f166928ed1d84d7b49cba7.svg";
export { ForwardRef as ReactComponent };